import React from "react";
import RoundedLinkButton from "../../../components/Buttons/RoundedLinkButton/RoundedLinkButton";
import { landlordFAQItems } from "./data";
import SEOTags from "../../../utils/SEOTags";
import Accordion from "../../../components/Accordion/Accordion";
import { jsonLdSchema } from "./markup";

const LandlordFAQ = () => {
  return (
    <>
      <SEOTags
        title={"För Hyresvärden   "}
        description={"Kostar det något att annonsera sin lokal?"}
        canonicalUrl={"/fragor-och-svar/hyresvard"}
        ogImage={"/images/logo/meta-logo.jpg"}
        structuredData={jsonLdSchema}
      />
      <div className="accordion-wrapper">
        <h1>Hyresvärd på Vakansa</h1>
        <p className="under-title">Vanliga frågor och svar kring att vara hyresvärd på Vakansa</p>
        <Accordion items={landlordFAQItems} />
        <div className="contact-back-button-wrapper">
          <p className="contact-info">
            För övriga frågor eller funderingar är du välkommen att kontakta oss på e-postadressen:{" "}
            <a href="mailto:info@vakansa.se">info@vakansa.se</a> eller telefon nummer:{" "}
            <a href="tel:+46767065662">Telefon: 076-706 56 62</a>
            <br />
            <br />
          </p>
          <br />
          <RoundedLinkButton label="Tillbaka" size="md" color="white" href="/fragor-och-svar" />
        </div>
      </div>
      <main className="faq-info-wrapper">
        <h1>Hyresvärd på Vakansa</h1>
        <p className="under-title">Vanliga frågor och svar kring att vara hyresvärd på Vakansa</p>
        {landlordFAQItems.map((item, index) => (
          <div key={index}>
            <h2>{item.title}</h2>
            <p>{item.content}</p>
          </div>
        ))}
        <br />
        <br />
        <p>
          För övriga frågor eller funderingar är du välkommen att kontakta oss på e-postadressen:{" "}
          <a href="mailto:info@vakansa.se">info@vakansa.se</a> eller telefon nummer:{" "}
          <a href="tel:+46767065662">Telefon: 076-706 56 62</a>
          <br />
          <br />
        </p>
        <br />
        <RoundedLinkButton label="Tillbaka" size="md" color="white" href="/fragor-och-svar" />
      </main>
    </>
  );
};

export default LandlordFAQ;
